module.exports = __webpack_public_path__ + "img/img4.aef94a76.png";